export default __webpack_public_path__ + "40b197d5f3e50b24ff91d0b935669aff.png";